// @ts-nocheck
/**
 * Calculators Page with Carbon Design System compliance
 * Wraps EducationalCalculators with proper layout, header, and footer
 */

import React from 'react';
import { Grid, Column, Breadcrumb, BreadcrumbItem } from '@carbon/react';
import { EducationalCalculators } from '../../components/calculators/EducationalCalculators';
import MarketingHeader from '../../components/marketing/MarketingHeader';
import MarketingFooter from '../../components/marketing/MarketingFooter';
import type { MarketingVariant } from '../../routes/MarketingRouter';

interface CalculatorsPageProps {
  variant?: MarketingVariant;
}

const CalculatorsPage: React.FC<CalculatorsPageProps> = ({ variant = 'default' }) => {
  const breadcrumbs = [
    { href: '/', text: 'Home' },
    { href: '/features', text: 'Features' },
    { href: '/calculators', text: 'Educational Calculators' },
  ];

  return (
    <div className="calculators-page">
      <MarketingHeader variant={variant} />

      <Grid className="calculators-page__content" fullWidth>
        <Column lg={16} md={8} sm={4} className="calculators-page__breadcrumb">
          <Breadcrumb noTrailingSlash aria-label="Page navigation">
            {breadcrumbs.map((crumb, index) => (
              <BreadcrumbItem key={index} href={crumb.href} isCurrentPage={index === breadcrumbs.length - 1}>
                {crumb.text}
              </BreadcrumbItem>
            ))}
          </Breadcrumb>
        </Column>

        <Column lg={16} md={8} sm={4}>
          <EducationalCalculators />
        </Column>
      </Grid>

      <MarketingFooter />

      <style jsx>{`
        .calculators-page {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }

        .calculators-page__content {
          flex: 1;
          padding-top: var(--cds-spacing-07);
          padding-bottom: var(--cds-spacing-09);
        }

        .calculators-page__breadcrumb {
          margin-bottom: var(--cds-spacing-06);
        }
      `}</style>
    </div>
  );
};

export default CalculatorsPage;
